import { GenericTimerClockContainer } from './components/wrapperStyledComponents'

export default function GenericTimerSelectionWrapper({ children, ...rest }) {
  return <GenericTimerClockContainer>{children}</GenericTimerClockContainer>
}
